<app-scotty-card [title]="'Settings' | translate" hideDivisor="true">

  <ng-container *ngIf="!isLoading; else loading">


    <!-- Bot configuration -->
    <div class="group-title">{{ 'Bot configuration' | translate }}</div>
    <form #botForm class="group">

      <!-- Bot Id -->
      <mat-form-field>
        <mat-label>{{ 'Bot ID' | translate }}</mat-label>
        <input matInput [(ngModel)]="bot.endpointBotId" [ngModelOptions]="{standalone: true}">
      </mat-form-field>

      <!-- Bot URL -->
      <mat-form-field>
        <mat-label>{{ 'Bot URL' | translate }}</mat-label>
        <input #botURL matInput type="url" [(ngModel)]="bot.endpointUrl" [ngModelOptions]="{standalone: true}" pattern="https?://.+">
        <mat-error *ngIf="botURL.value.length > 0">{{ 'URL not valid' | translate }}</mat-error>
      </mat-form-field>

      <!-- Bot image URL -->
      <mat-form-field>
        <mat-label>{{ 'Bot image URL' | translate }}</mat-label>
        <input #botURL matInput type="url" [(ngModel)]="bot.imageUrl" [ngModelOptions]="{standalone: true}" pattern="https?://.+">
        <mat-error *ngIf="botURL.value.length > 0">{{ 'URL not valid' | translate }}</mat-error>
      </mat-form-field>

    </form>


    <!-- Cartographic console -->
    <div class="group-title">{{ 'Cartographic console configuration' | translate }}</div>
    <form #cartographicConsoleForm class="group">

      <!-- Console URL -->
      <mat-form-field>
        <mat-label>{{ 'URL' | translate }}</mat-label>
        <input #cartographicConsoleURL matInput type="url" [(ngModel)]="cartographicConsoleConfig.endpointUrl" [ngModelOptions]="{standalone: true}" pattern="https?://.+">
        <mat-error *ngIf="cartographicConsoleURL.value.length > 0">{{ 'URL not valid' | translate }}</mat-error>
      </mat-form-field>

    </form>


    <!-- General configs -->
    <div class="group-title">{{ 'General' | translate }}</div>
    <form #langForm class="group">

      <!-- Language -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'Language' | translate }}</mat-label>
        <mat-select [(ngModel)]="language" [ngModelOptions]="{standalone: true}">
          <mat-option *ngFor="let lang of translateService.langs" [value]="lang">
            {{LanguageToString[lang] | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </form>


    <!-- Save settings -->
    <button class="save" mat-raised-button color="primary" (click)="save()" [disabled]="!botForm.checkValidity() || !cartographicConsoleForm.checkValidity() || !langForm.checkValidity()">{{ 'Update settings' | translate }}</button>


  </ng-container>

</app-scotty-card>


<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
